import { JsonCopier } from "./components/JsonCopier";
import "./index.css";

export function App() {
  return (
    <div className="app">
      <JsonCopier />
    </div>
  );
}

export default App;
